import { css } from '@emotion/react';

const chargeWaitStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '56px',

        '@media (min-width: 600px)': {
            paddingTop: '24px',
        },
    }),
    containerTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '19px',
        lineHeight: '23px',
        color: '#000000',
        margin: '15px 0',
    }),
    description: css({
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '20px',
        color: '#000000',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '20px',
    }),
    infoImageContainer: css({
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '86px',

        '@media (min-width: 600px)': {
            margin: '36px 0',
        },
    }),
    infoImageContent: css({
        maxWidth: '20rem',
    }),
    infoImage: css({
        width: '100%',
        zIndex: 1,
        mixBlendMode: 'luminosity',
        ':after': {
            content: '""',
            background: 'white',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: -1,
        },
    }),
    attempts: css({
        justifyContent: 'center',
    }),
};

export default chargeWaitStyles;
